exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item{border-radius:8px;padding:15px;box-sizing:border-box;position:relative;animation-name:item;animation-duration:.4s;display:inline-block;text-align:left;animation-fill-mode:backwards}.preload:before{content:\"\";position:absolute;top:0;bottom:0;left:0;right:0;display:block;background:linear-gradient(90deg,hsla(0,0%,100%,0),hsla(0,0%,100%,.5),hsla(0,0%,100%,0));-webkit-animation:_1IOU .8s linear infinite;animation:_1IOU .8s linear infinite}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-baa0b48a","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/general-stats.vue
// module id = 89
// module chunks = 0